import { getToken } from "@/core/firebase";
import { configureSeeriApi } from "@/core/seeri-api";

import { locale } from "@/config/locale";
import { getBaseURL } from "@/config/remote";

export const refreshSeeriApiConfig = async (countryCode?: string) => {
  const baseURL = await getBaseURL(locale);
  const country = countryCode ? countryCode : (localStorage.getItem("country") ?? "co");

  const accessToken = (await getToken()) || "";
  configureSeeriApi({ country, baseURL, accessToken });
};
